<form #addEditLabelForm="ngForm" (ngSubmit)="save()">
    @let isLabelNameInvalid = addEditLabelForm.controls?.labelName?.dirty && formModel().labelName.length === 0;
    @let isColorCodeRequired = addEditLabelForm.controls?.colorCode?.dirty && formModel().colorCode.length === 0;
    @let isColorCodeInvalid = addEditLabelForm.controls?.colorCode?.dirty && addEditLabelForm.controls?.colorCode?.errors?.['pattern'];

    <div class="tw-flex tw-flex-col tw-gap-2 tw-pt-8">
        <label class="tw-mb-0" for="labelName">{{ 'admin.labels.form.titleLabel' | transloco }}<span class="tw-text-red-500">*</span></label>
        <input pInputText
            data-test="admin-labelsDialog-label-input"
            id="labelName"
            name="labelName"
            required="true"
            [placeholder]="'admin.labels.form.titlePlaceholder' | transloco"
            [(ngModel)]="formModel().labelName"
        />
        @if (isLabelNameInvalid) {
            <small class="tw-text-red-500">{{ 'admin.labels.form.titleRequired' | transloco }}</small>
        }
    </div>
    <div class="tw-flex tw-flex-col tw-gap-2 tw-pt-8">
        <label class="tw-mb-0" for="colorCode">{{ 'admin.labels.form.colorLabel' | transloco }}<span class="tw-text-red-500">*</span></label>
        <!-- color picker here -->
        <div class="tw-flex tw-items-center tw-gap-2">
            <input
                pInputText
                data-test="admin-labelsDialog-color-input"
                [(ngModel)]="formModel().colorCode"
                id="colorCode"
                name="colorCode"
                maxlength="7"
                pattern="^#([A-Fa-f0-9]{6})$"
                [placeholder]="'admin.labels.form.colorPlaceholder' | transloco"
                required="true"
            />
            <p-colorpicker
                data-test="admin-labelsDialog-color-picker"
                [(ngModel)]="formModel().colorCode"
                name="colorCodePicker"
                appendTo="body"
            >
            </p-colorpicker>
        </div>
        @if (isColorCodeRequired) {
            <small class="tw-text-red-500">{{ 'admin.labels.form.colorRequired' | transloco }}</small>
        }

        @if (isColorCodeInvalid) {
            <small class="tw-text-red-500">{{ 'admin.labels.form.colorInvalid' | transloco }}</small>
        }
    </div>
    <div class="tw-flex tw-justify-end tw-pt-8">
        <p-button [label]="'admin.labels.form.cancelButtonLabel' | transloco"
            severity="secondary"
            class="tw-mr-4"
            data-test="admin-labelsDialog-cancel-button"
            (onClick)="cancel()"
        />
        <p-button [label]="'admin.labels.form.saveButtonLabel' | transloco"
            severity="primary"
            data-test="admin-labelsDialog-save-button"
            type="submit"
            [disabled]="addEditLabelForm.invalid"
        />
    </div>
</form>
